var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { IconButton } from '@doordash/component-button';
import { Separator } from './budget_form_styles';
import { Stack, StackChildren, Text, InlineChildren, } from '@doordash/design-language';
export var Collapsible = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, title = _a.title, children = _a.children, buttonTestId = _a.buttonTestId;
    var _c = __read(React.useState(open), 2), isOpen = _c[0], setIsOpen = _c[1];
    var toggleSectionOpening = function () {
        setIsOpen(function (prev) { return !prev; });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { size: Stack.Sizes.XSmall },
            React.createElement(InlineChildren, { size: InlineChildren.Sizes.Medium, justifyContent: InlineChildren.Justification.SpaceBetween },
                React.createElement(Text, { styles: Text.Styles.Title2, color: Text.Colors.TextPrimary }, title),
                !isOpen ? (React.createElement(IconButton, { accessibilityLabel: title + "-open section button", iconType: IconButton.IconTypes.ChevronDown, onClick: toggleSectionOpening, "data-testid": buttonTestId })) : (React.createElement(IconButton, { accessibilityLabel: "Close Section Button", iconType: IconButton.IconTypes.ChevronUp, onClick: toggleSectionOpening, "data-testid": buttonTestId }))),
            React.createElement(Separator, null)),
        React.createElement(StackChildren, { size: StackChildren.Sizes.Large }, isOpen && (React.createElement(React.Fragment, null,
            children,
            React.createElement(Separator, null))))));
};
export default Collapsible;
